import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['player', 'controls'];

  playerTarget!: HTMLVideoElement;
  controlsTarget!: HTMLDivElement;

  play(): void {
    this.playerTarget.play();
  }

  handlePlay(): void {
    // Switch from our custom button to native controls on first play
    this.playerTarget.setAttribute('controls', 'controls');
    this.controlsTarget.classList.add('hidden!');
  }
}
